<template>
<div>
     <div class="container full-width navbar">
                <!-- <a href="/">
                    <div class="logo has-background-primary transition-medium">
                        <div class="logo-wrap">
                            <img class="logo_large transition-medium" src="@/assets/images/logo.svg">
                            <img class="logo_small transition-medium" src="@/assets/images/logo_small.svg">
                        </div>

                    </div>
                </a> -->
                <!-- <div class="row top-bar justify-end align-center transition-medium">
                    <nav class="menu has-color-initial">
                        <ul>
                            <li class="menu-item"><router-link :to="{ name: 'submit' }">Submit Content</router-link></li>
                            <li class="menu-item"><router-link :to="{ name: 'contact_us' }">Contact Us</router-link></li>
                            <li class="menu-item"><router-link :to="{ path: '/about' }">About</router-link></li>
                        </ul> 
                    </nav>
                </div>  -->
                <div class="row bottom-bar has-background-primary justify-end align-center">
                        <nav class="menu has-color-initial">
                            <a href="/" style="padding-right: 10px;">Home</a>
                            <ul v-if="menu.length">
                                <!-- <li class="menu-item"><router-link :to="'/'">{{ menu[0].title }}</router-link></li> -->
                                <li class="has-children menu-item" v-for="m in menu[0].children" v-bind:key="m.slug">
                                    <a v-if="menu.length && m.url" v-bind:href="m.url">{{ m.title }}</a>
                                    <router-link v-if="menu.length && !m.url" :to="{ name: m.id}">{{ m.title }}</router-link>  
                                    <ul class="sub-menu" v-if="m.children !== null">
                                        <li class="menu-item" v-for="c in m.children" v-bind:key="c.slug"> 
                                            <a v-if="menu.length && c.url" v-bind:href="c.url">{{ c.title }}</a>
                                            <router-link v-if="menu.length && !c.url" :to="{ name: c.id}">{{ c.title }}</router-link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div class="menu-item search-wrap">
                                <input type="text" class="search" name="search" placeholder="Search" v-model="queryString" @keyup.enter="$router.push({ name: 'search', query: {q:queryString} })">
                                <router-link :to="{ name: 'search', query: {q: queryString}}"><i class="fas fa-search"></i></router-link>
                            </div>
                        </nav>
                        <div class="hamburger" v-on:click="isActive = !isActive">
                            <a href="#">
                                <div class="line has-background-initial"></div>
                                <div class="line has-background-initial"></div>
                                <div class="line has-background-initial"></div>
                            </a>
                        </div>
               
                </div>
                <div v-bind:class="{ active: isActive }" class="side-nav has-background-black has-color-initial transition-medium">
                    <div class="nav-header">
                        <a href="#" class="close-button" v-on:click="isActive = !isActive"><h5>Close Menu</h5></a>
                    </div>
                    <!-- <nav class="menu has-color-initial">
                        <ul>
                            <li class="menu-item"><a href="#">Submit Content</a></li>
                            <li class="menu-item"><a href="#">Contact Us</a></li>
                            <li class="menu-item"><a href="#">About</a></li>
                        </ul>
                    </nav> -->
                    <!-- <hr> -->
                    <nav class="menu has-color-initial">
                        <ul v-if="menu.length">
                            <li class="menu-item" v-on:click=" isActive = !isActive"><router-link :to="'/'">{{ menu[0].title }}</router-link></li>
                            <li class="has-children menu-item" v-for="m in menu[0].children" v-bind:key="m.slug" v-on:click=" isActive = !isActive">
                                <a v-if="menu.length && m.url" v-bind:href="m.url">{{ m.title }}</a>
                                <router-link v-if="menu.length && !m.url" :to="{ name: m.id}">{{ m.title }}</router-link>    
                                <ul class="sub-menu" v-if="m.children !== null">
                                    <li class="menu-item" v-for="c in m.children" v-bind:key="c.slug" v-on:click=" isActive = !isActive">
                                        <a v-if="menu.length && c.url" v-bind:href="c.url">{{ c.title }}</a>
                                        <router-link v-if="menu.length && !c.url" :to="{ name: c.id}">{{ c.title }}</router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>
                    <hr>
                    <ul>
                        <li class="menu-item search-wrap">
                            <input type="text" style='background-color: white' name="search" placeholder="Search" v-model="queryString" @keyup.enter="$router.push({ name: 'search', query: {q:queryString} })">
                            <router-link :to="{ name: 'search', query: {q: queryString}}"><i class="fas fa-search"></i></router-link>
                        </li>
                    </ul>
                </div>
            </div>
</div>
</template>

<script>
import axios from 'axios'
import Page from '../views/Page.vue'
export default{
    name: 'navigation',
    data() {
        return {
            menu: [],
            isActive: false,
            queryString: ''
        }    
    },
    mounted() {
        axios
        .get('/api/get_menu')
        .then((response) => {
            this.menu = response.data
        });
    },
    created(){
        // this.get_routes()
    },
    methods:{
        mobileMenu: function () {

        }
    }
}
</script>

<style scoped>

 /* a::before{
        width: 100%;
        height: 10px;
        background: pink;
    } */

</style>